import { store } from '../store/store';
import { selectUserPermissions } from '../store/slices/authSlice';

export const checkPermission = (category, action) => {
  const userGroupName = localStorage.getItem('userGroupName') || '';
  
  // Super-admin has access to everything
  if (userGroupName.toLowerCase() === 'super-admin' || userGroupName.toLowerCase() === 'superadmin') {
    return true;
  }
  
  const permissions = selectUserPermissions(store.getState());
  return permissions[category]?.[action] || false;
};

export const showAccessDeniedToast = () => {
  // You can use any toast library here (e.g., react-toastify)
  alert("You don't have access to this feature");
};

// Permission categories
export const PERMISSIONS = {
  USER: 'USER',
  APP_USERS: 'APP_USERS',
  USER_DETAILS: 'USER_DETAILS',
  APP_USER_DETAILS: 'APP_USER_DETAILS',
  YOJNA: 'YOJNA',
  SCHEMES: 'SCHEMES',
  SYSTEM_USERS: 'SYSTEM_USERS',
  MASTERS: 'MASTERS',
  REPORTS: 'REPORTS'
};

// Permission actions
export const ACTIONS = {
  CREATE: 'create',
  READ: 'read',
  WRITE: 'write',
  IMPORT: 'import',
  EXPORT: 'export'
};

// Tab names for visibility control
export const TABS = {
  HOME: 'home',
  APP_USERS: 'appUsers',
  SCHEMES: 'schemes',
  SYSTEM_USERS: 'systemUsers',
  USER_GROUPS: 'userGroups',
  MASTERS: 'masters',
  REPORTS: 'reports',
  AUDIT_LOGS: 'auditLogs'
}; 